import { styled } from '@mui/material/styles';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const MoreDetailsAccordion = styled(Accordion)(({ theme }) => ({
  marginTop: theme.spacing(2),
  boxShadow: 'none',
  borderTop: `1px solid ${theme.palette.divider}`,
  '&:before': { display: 'none' },
}));

export const MoreDetailsSummary = styled(AccordionSummary)(({ theme }) => ({
  minHeight: 44,
  '& .MuiAccordionSummary-content': {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

export const ExpandMoreIconStyled = styled(ExpandMoreIcon)(({ theme }) => ({
  color: theme.palette.turn_violet.main,
}));

export const MoreDetailsAction = styled(Typography)(({ theme }) => ({
  width: 75,
  color: theme.palette.turn_violet.main,
  fontWeight: 600,
  textDecoration: 'underline',

  '&:hover': {
    cursor: 'pointer',
    textDecoration: 'none',
  },
}));

export const MoreDetailsBody = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(1, 0),
}));
